<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l"
    >
      <el-row
type="flex"
align="middle">
        <SelectOrg
          v-if="!orgInfo"
          class="text-search mr-m"
        />
        <el-input
          v-model="textSearch"
          class="text-search mr-m"
          size="small"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <el-button
          size="small"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import SelectOrg from "@/components/items/SelectOrg"
export default {
  name: "CardFilter",
  components: {
    SelectOrg
  },
  props: {
    orgInfo: Object
  },
  data() {
    return {
      textSearch: "",
    };
  },
  computed: {},
  methods: {
    searchNormal() {
      this.$emit("search", {
        searchText: this.textSearch,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
